import styled from 'styled-components';

export const FiltersWrapper = styled.div`
  margin-bottom: 24px;
`;

export const Filter = styled.div`
  margin-bottom: 8px;
`;
